export default Object.freeze({
  Strength: 1,
  Need: 2,
});
